import { render } from "./ClientPayments.vue?vue&type=template&id=03df101f&scoped=true"
import script from "./ClientPayments.vue?vue&type=script&lang=js"
export * from "./ClientPayments.vue?vue&type=script&lang=js"

import "./ClientPayments.vue?vue&type=style&index=0&id=03df101f&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03df101f"]])

export default __exports__